import { ArrowCounterClockwise } from "@phosphor-icons/react"
import { IconButton } from "../../reusable/Button"
import { Tooltip } from "../../reusable/Tooltip"

type ResetButtonProps = {
  onClick: () => void
  tooltip: string
}

export const ResetButton = ({ onClick, tooltip }: ResetButtonProps) => {
  return (
    <Tooltip title={tooltip}>
      <IconButton variant="transparent" size="sm" onClick={onClick}>
        <ArrowCounterClockwise className="w-4 h-4" />
      </IconButton>
    </Tooltip>
  )
}
